import api from '../api';

const domainApi = {
  // Thêm domain mới
  addDomain: async (data) => {
    return api.post('/domains/add', data);
  },

  // Lấy danh sách domain của user
  getDomainsByUser: async (userId) => {
    return api.get(`/domains/user/${userId}`);
  },

  // Cập nhật trạng thái domain
  updateDomainStatus: async (domainId, status) => {
    return api.put(`/domains/${domainId}/status`, { status });
  },

  // Xóa domain
  deleteDomain: async (domainId) => {
    return api.delete(`/domains/${domainId}`);
  },

  // Gửi domain ra hệ thống bên ngoài
  sendToExternalSystem: async (endpoint, domains) => {
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: domains
    });
  }
};

export default domainApi; 